export default __webpack_public_path__ + "media/images/user_photos/103-4fa6a6892b73e3f3d259333408647a5b.jpg";